import React from "react";
import { TitleHolder } from "../../common/sharedComponents/styles/card.style";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import BusinessUnitContent from "./components/businessUnitContent";

export default function BusinessUnit() {
  return (
    <div>
      <TitleHolder>Create Business Unit</TitleHolder>
      <StepperContentHolder>
        <BusinessUnitContent />
      </StepperContentHolder>
    </div>
  );
}
